import { render, staticRenderFns } from "./DunningActivity.vue?vue&type=template&id=89de8f7c&"
import script from "./DunningActivity.vue?vue&type=script&lang=js&"
export * from "./DunningActivity.vue?vue&type=script&lang=js&"
import style0 from "./DunningActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports